module.exports = __webpack_public_path__ + "static/media/item_sli_insight_des.5e8ea446.png";